import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import noop from 'lodash/noop';
import RadioWithTracking from '@Pages/ProfileSettings/Preferences/components/RadioWithTracking';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import './TwoLevelRadio.custom.scss';
// This component partially implements rx-option-types directive in React
function TwoLevelRadio({ option, value, onChange }) {
  const id = `radio-button-${option.value}`;
  const selectedSuboption = option.subOptions.find((suboption) => suboption.value === value);

  return (
    <div id={`two-level-radio-${option.name || option.value}`}>
      <div className="clearfix">
        <RadioButtonGroup.Option
          className={cn('structure-editor__radio-option')}
          id={id}
          name={option.name}
          checked={!!selectedSuboption}
          onChange={() => {
            if (!selectedSuboption && !option.disabled) {
              onChange(option.subOptions[0].value);
            }
          }}
          label={option.title}
          value={(selectedSuboption && selectedSuboption.value) || option.subOptions[0].value}
          aria-expanded={!!selectedSuboption}
          aria-label={`Search this structure ${option.title.toLowerCase()}`}
          disabled={option.disabled}
        />
      </div>
      <div className={cn(`fragments fragments-${option.name} clearfix`, !selectedSuboption && 'u-els-hide-visually')}>
        {option.subOptions.map((suboption) => (
          <RadioWithTracking
            key={`${suboption.name}-${suboption.value}`}
            id={`radio-button-${suboption.value}`}
            currentValue={selectedSuboption && selectedSuboption.value}
            name={suboption.name}
            label={suboption.title}
            value={suboption.value}
            onChange={onChange}
            aria-label={`Search this structure ${suboption.title.toLowerCase()}`}
          />
        ))}
      </div>
    </div>
  );
}

TwoLevelRadio.propTypes = {
  option: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.string,
    subOptions: PropTypes.array,
    disabled: PropTypes.bool,
  }),
  value: PropTypes.string,
  onChange: PropTypes.func,
};

TwoLevelRadio.defaultProps = {
  onChange: noop,
};

export default TwoLevelRadio;
